import { Injectable } from '@angular/core';
import Gleap from 'gleap';
import { User } from '../models/user';
import { IntercomSettings } from '@intercom/messenger-js-sdk/types';
import { isWorkEmail } from '../utils/non-work-emails';
import { ConfigurationService } from './configuration.service';
interface IIntercomCompanySettings {
    id: string;
    website: string;
    name: string;
}
@Injectable({
    providedIn: 'root',
})
export class GleapService {
    private gleapInitialized = false;
    constructor(private configService: ConfigurationService) {}

    init(user: User) {
        if (!this.gleapInitialized) {
            const utmParams: any = {};
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (
                    key?.startsWith('utm_') &&
                    key in
                        ({
                            utm_term: '',
                            utm_content: '',
                            utm_medium: '',
                            utm_campaign: '',
                            utm_source: '',
                        } as IntercomSettings)
                ) {
                    utmParams[key] = localStorage.getItem(key) || '';
                }
            }
            let company: IIntercomCompanySettings;
            const userBranding = user.branding?.company;
            if (userBranding) {
                const isWorkingEmail = isWorkEmail(userBranding.domain ?? userBranding.name ?? '');
                if (isWorkingEmail) {
                    company = {
                        id: userBranding.id,
                        name: userBranding.name,
                        website: userBranding.domain ?? userBranding.id,
                    };
                }
            }
            Gleap.initialize(this.configService.gleapKey);
            Gleap.identify(user.email, {
                name: user.name ?? user.email,
                email: user.email,
                companyName: company?.name,
                companyId: company?.id,
                ...utmParams,
                website: company?.website,
                utm_source: utmParams.utm_source || '',
                utm_medium: utmParams.utm_medium || '',
                utm_campaign: utmParams.utm_campaign || '',
                utm_content: utmParams.utm_content || '',
                utm_term: utmParams.utm_term || '',
            });
            this.gleapInitialized = true;
        }
    }
    open() {
        Gleap.open();
    }
    startConversation() {
        Gleap.startConversation();
    }
    hide() {
        Gleap.showFeedbackButton(false);
    }
    show() {
        Gleap.showFeedbackButton(true);
    }
    shutdown() {
        this.hide();
        if (this.gleapInitialized) {
            this.gleapInitialized = false;
        }
    }
}
